// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"bedfc741313bc4c912ed","210":"a1288604abb734c02c6b"}[chunkId] + ".bundle.js";
};